import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import cn from 'classnames';

interface Props {
  currIndex: number;
  arrLength: number;
  onMove: (index: number) => void;
  className?: string;
}

const PrevNextButtons: React.FC<Props> = ({ currIndex, arrLength, onMove, className, children }) => {
  const computePrevIndex = (): number => {
    let index = currIndex - 1;
    if (index < 0) {
      index = arrLength - 1;
    }
    return index;
  };

  const computeNextIndex = (): number => {
    let index = currIndex + 1;
    if (index == arrLength) {
      index = 0;
    }
    return index;
  };

  return (
    <div className={cn(className, 'flex gap-x-2 items-center')}>
      <div>
        <StyledArrowButton
          className="bg-blue-700 text-white px-1.5 py-0.5 h-6 leading-none"
          onClick={() => onMove(computePrevIndex())}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </StyledArrowButton>
      </div>
      {children}
      <div>
        <StyledArrowButton
          className="bg-blue-700 text-white px-1.5 py-0.5 h-6 leading-none"
          onClick={() => onMove(computeNextIndex())}
        >
          <FontAwesomeIcon icon={faAngleRight} />
        </StyledArrowButton>
      </div>
    </div>
  );
};

const StyledArrowButton = styled.button`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  background: #2d53f1;

  svg {
    height: 1rem;
  }
`;

export default PrevNextButtons;
